module.exports = __webpack_public_path__ + "static/media/adobeaudition.58f3d81d.svg";